import { TextField, useFormContext } from '@calendly/form';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { useEffect, forwardRef } from 'react';
import { INPUT_COMPONENT_NAME } from './constants';
const styledTextFieldWrapperCss = "sehwkh8";
const StyledTextFieldWrapper = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(styledTextFieldWrapperCss, props.className)} />;
});
const styledSpanCss = "s1dlzszj";
const StyledSpan = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'span';
  return <Component ref={ref} {...restProps} className={classNames(styledSpanCss, props.className)} />;
});
const styledTextFieldCss = "sdpp8bz";
const StyledTextField = forwardRef((props, ref) => <TextField ref={ref} {...props} className={classNames(styledTextFieldCss, props.className)} />);
export const AccessOwnerTextInput = ({
  label,
  placeholder,
  optionField
}) => {
  const {
    values: {
      accessOwnerType,
      existingSettingType,
      existingSettingValue
    },
    setFieldValue,
    setErrors
  } = useFormContext();
  useEffect(() => {
    if (accessOwnerType === optionField) {
      const currentValue = optionField === existingSettingType ? existingSettingValue : '';
      setFieldValue(INPUT_COMPONENT_NAME, currentValue);
      setErrors({});
    }
  }, [accessOwnerType, optionField, existingSettingType, existingSettingValue, setFieldValue, setErrors]);
  if (accessOwnerType !== optionField) {
    return null;
  }
  return <StyledTextFieldWrapper>
      <StyledSpan>{label}</StyledSpan>
      <StyledTextField name={INPUT_COMPONENT_NAME} placeholder={placeholder} aria-label={label} />
    </StyledTextFieldWrapper>;
};
AccessOwnerTextInput.propTypes = {
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  optionField: PropTypes.string.isRequired
};

require("./access_owner_text_input.wyw-in-js.css!=!../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./access_owner_text_input.js");